import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { PermissionsEnum } from 'src/app/constants/settings.enum';

@Component({
  selector: 'app-signing-methods',
  templateUrl: './signing-methods.component.html'
})
export class SigningMethodsComponent implements OnInit {
  @Input('signatureMethodSettings') signatureMethodSettings: any = [];
  @Output('updateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();

  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;
  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  toggleChanged(event: any) {
    let key: string = (event.target as HTMLInputElement).id;
    let checked: boolean = (event.target as HTMLInputElement).checked;
    this.updateOrganisationSettings.emit({ checked, key });
  }

}

